import React from 'react'
import image from '../../../assets/logo-idecba.png'
function BannerAdhere() {
  return (
    

<div className="panel-horizontal-content">
  <div className="panel-horizontal d-flex flex-column flex-md-row justify-content-between align-items-center w-100">
    <div className="w-100 mb-3 mb-md-0"> 
      <h3 className="card-title text-dark">MODELO DE CARTA DE ADHESIÓN</h3>
      <img src={image} alt="descripción de imagen" className="card-img" />
    </div>
    
    <div className="card-body d-flex justify-content-center w-100">
      
    </div>
  </div>
</div>



  )
}

export default BannerAdhere